import React from 'react';
import { createRoot } from 'react-dom/client';
import MinSide from '../pages/minside/MinSide.jsx';

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('minside-app');

    const root = createRoot(container);
    root.render(<MinSide />);
});
